import React from "react";
import Image from "react-bootstrap/Image";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";
import styles from "./RoundedMediaPlusContent.module.scss";

function RoundMediaPlusContent({ image, content }) {
  return (
    <Row
      className={`${styles.roundMediaPlusContent} d-flex align-items-center`}
    >
      <Col xs={"auto"}>
        <div className={`${styles.imgHolder}`}>
          <Link to="/" className="stretched-link">
            <Image
              roundedCircle
              src={image}
              className={`${styles.img} smooth`}
            />
          </Link>
        </div>
      </Col>
      <Col>
        <h6
          style={{ fontSize: "16px" }}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </Col>
    </Row>
  );
}

export default RoundMediaPlusContent;
